import { sortBy } from "lodash";
import React from "react";
import { EquipmentCatalogItem, Experience, GiftOffer, UnitType } from "types";
import shallow from "zustand/shallow";
import { EquipmentItem } from "./CreatePurchaseEquipmentPicker";
import { useProduct } from "@/hooks/resources/useProduct";
import { getCatalogItemsByUnitType } from "@/models/Catalog";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const CreatePurchaseGiftEquipmentPicker = () => {
    const giftOffer = useCreatePurchaseStore((state) => state.getActiveProduct<GiftOffer>());
    const { data: experience } = useProduct<Experience>(giftOffer?.experience?.id);
    const equipmentLineItems = useCreatePurchaseStore((state) => state.getEquipmentLineItems(), shallow);
    const totalEquipmentQuantity = equipmentLineItems.reduce((sum, lineItem) => sum + lineItem.quantity, 0);

    if (!experience) {
        return null;
    }

    const equipmentCatalogItems = getCatalogItemsByUnitType(experience.catalog?.items ?? [], UnitType.EQUIPMENT);
    const sortedItems = sortBy(equipmentCatalogItems as EquipmentCatalogItem[], "sequence");

    if (sortedItems.length === 0) {
        return null;
    }

    return (
        <div className="space-y-2">
            <div className="text-sm font-bold">Quantity</div>
            <div className="flex flex-col space-y-2">
                {sortedItems.map((catalogItem) => (
                    <EquipmentItem
                        key={catalogItem.template?.id ?? catalogItem.id ?? catalogItem.name}
                        catalogItem={catalogItem}
                        totalEquipmentQuantity={totalEquipmentQuantity}
                    />
                ))}
            </div>
        </div>
    );
};
